import { Token } from 'config/types'
import { TransactionStatusEnum } from 'config/types/transaction'
import { useMemo, useState } from 'react'

export interface IControllPaymentFilter<T> {
  filters: T
  onChange: <K extends keyof T>(key: K, value: T[K]) => void
  onSubmit: (values: T) => void

  reset: () => void
  submit: () => void
  force: (values: T) => void
  isInvalid: boolean
  isFiltering: boolean
}

export const useTransactionFilter = <T = Record<string, string>>({
  initialData,
  onSubmit: onSubmitProps,
}: {
  initialData: T
  onSubmit?: (keys: T) => void

  key?: string
}): IControllPaymentFilter<T> => {
  const [filters, setFilter] = useState<T>(initialData)

  const onChange = <K extends keyof T>(key: K, value: T[K]) => {
    setFilter((prev) => ({
      ...prev,
      [key]: value,
    }))
  }

  const force = (values: T) => {
    setFilter(values)
  }

  const reset = () => {
    setFilter(
      Object.keys(filters).reduce((state, key) => {
        state[key] = null
        return state
      }, {} as T),
    )
  }

  const submit = () => {
    if (typeof onSubmitProps === 'function') {
      onSubmitProps(filters)
    }
  }

  // event callback
  const onSubmit = (values: T) => {
    setFilter(values)
  }

  return useMemo(() => {
    const isFiltering = Object.values(filters).some((item) => item)

    return {
      filters,
      submit,
      reset,
      force,

      onChange,
      onSubmit,
      isFiltering,
      isInvalid: !(initialData ? JSON.stringify(filters) !== JSON.stringify(initialData) : isFiltering),
    }
  }, [initialData, filters])
}

export interface IPaymentTransactionFilter {
  currency: Token
  status: TransactionStatusEnum
  fromDate: number
  toDate: number
}
export const initialDataPaymentTransaction = {
  currency: null,
  status: null,
  fromDate: null,
  toDate: null,
}
